import { type ReactNode, useEffect, useState } from 'react';
import { useStorage } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { Triggers } from '../helpers';

type CallWidgetRenderData = {
  showWindow: boolean;
  onClick: () => void;
};

export type CallWidgetProps = {
  children: (data: CallWidgetRenderData) => ReactNode;
};

export function CallWidget(props: CallWidgetProps) {
  const { children: renderData } = props;
  const settings = useSettings();
  const {
    buttonIconVisible,
    buttonText,
    deactivate,
    triggersTimeOnPage,
    triggersTimeOnSite,
    triggersScrollPosition,
    triggersExiIntent,
    phone,
    windowPicture,
    windowName,
    windowCaption,
    windowText,
    windowBackgroundColor,
    windowTextColor,
    windowPhoneColor,
    windowNameFontSize,
    windowCaptionFontSize,
    windowTextFontSize,
    windowPhoneFontSize,
    editMode
  } = settings;
  const firstVisitStorage = useStorage('firstVisit', undefined);
  const wasIntentStorage = useStorage('wasIntent', undefined);
  const triggers = new Triggers(settings, {
    firstVisit: firstVisitStorage,
    wasIntent: wasIntentStorage
  });
  const [showWindow, toggleShowWindow] = useState(false);
  const onClick = () => {
    toggleShowWindow(!showWindow);
  };

  useEffect(() => {
    if (!editMode) {
      triggers.init().then(() => {
        toggleShowWindow(true);
      });

      return () => toggleShowWindow(false);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [
    triggersTimeOnPage,
    triggersTimeOnSite,
    triggersScrollPosition,
    triggersExiIntent
  ]);

  useEffect(() => {
    if (editMode) {
      toggleShowWindow(false);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonIconVisible, buttonText]);

  useEffect(() => {
    if (editMode) {
      toggleShowWindow(true);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [
    phone,
    windowPicture,
    windowName,
    windowCaption,
    windowText,
    windowBackgroundColor,
    windowTextColor,
    windowPhoneColor,
    windowNameFontSize,
    windowCaptionFontSize,
    windowTextFontSize,
    windowPhoneFontSize
  ]);

  return renderData({
    showWindow: showWindow && !deactivate,
    onClick
  });
}
